<template>
    <!-- 检测中心 -->
    <div
        v-loading="loading"
        class="check-center"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0)"
    >
        <div class="dfc check-center-head">
            <span class="mr15"
                >剩余产品图片检测个数：<font class="orange">{{ fwRechargeCount }}</font
                >个</span
            >
            <el-button type="primary" size="small" style="background: #ff6000; border-color: #ff6000" @click="showMeal"
                >立即购买</el-button
            >
            <span class="blue ml10 mr20 dfc curp" @click="getFwCount"
                ><i class="iconfont-npm icon-npm-shuaxin mr3"></i>刷新</span
            >
            <span class="blue curp" @click="$refs.purchaseRecord.show()">查看购买记录</span>
        </div>
        <div class="check-center-body">
            <div class="check-center-body-left">
                <img src="//oss.fjdaze.com/aliProject/images/wjcIconLeft.png" alt="" />
            </div>
            <div class="check-center-body-right">
                <div class="check-center-body-item">
                    <div class="title">检测范围：</div>
                    <div>
                        <div>
                            <el-radio-group v-model="productionPosition" @change="getGoodsNum">
                                <el-radio :label="0">销售中的产品</el-radio>
                                <el-radio :label="1">待上架的产品</el-radio>
                            </el-radio-group>
                        </div>
                        <div style="background: #f8f8f8; padding: 15px 10px; width: 520px" class="mt10">
                            <div>
                                <el-radio v-model="chooseWay" :label="0">全部</el-radio>
                            </div>
                            <div class="mt10">
                                <el-radio v-model="chooseWay" :label="1">手动选择</el-radio>
                                <span class="blue ml28 curp" @click="choosePro">选择</span>
                                <span v-show="chooseWay === 1 && showNum" class="ml20 color99"
                                    >已选 {{ showNum }} 个产品</span
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="check-center-body-item">
                    <div class="title">检测数量：</div>
                    <div>{{ showNum }}个</div>
                </div>
                <div class="check-center-body-item">
                    <div class="title">检测内容：</div>
                    <div>
                        <p>
                            <el-checkbox v-model="fwWord">标题违禁词</el-checkbox>
                        </p>
                        <p class="mt10">
                            <el-checkbox v-model="fwAttribute">属性违禁词</el-checkbox>
                        </p>
                        <p class="mt10">
                            <el-checkbox v-model="fwSku">SKU违禁词</el-checkbox>
                        </p>
                        <p class="mt10">
                            <badge txt="预防职业打假" :txt-style="{ left: '105%', bottom: '70%' }"
                                ><el-checkbox v-model="fwImage"
                                    >图片违禁词<font class="color99">（主图+详情图）</font></el-checkbox
                                ></badge
                            >
                        </p>
                        <p v-show="fwImage" class="img-check-tip mt5">
                            文字检测免费，图片违禁词需另外付费，若剩余产品图片检测个数不足时，需提前订购。
                            <el-button
                                type="primary"
                                size="mini"
                                style="background: #ff6000; border-color: #ff6000"
                                @click="showMeal"
                                >立即购买</el-button
                            >
                        </p>
                    </div>
                </div>
                <el-button
                    type="primary"
                    style="width: 140px; height: 46px; margin: 35px 0 0 120px"
                    @click="startCheckBtn"
                    >开始检测</el-button
                >
            </div>
        </div>
        <div class="check-center-foot mt40">
            <h2 class="fontWB">违禁词说明</h2>
            <p class="mt5">
                <i>1</i
                >目前有大量的职业打假人一次就敲诈<em>几千上万</em>，还有会举报到工商，税务等机构，这些机构查起来一罚就要<em
                    >20万</em
                >
            </p>
            <p class="mt5">
                <i>2</i
                >产品图片违禁词检测，需点击上方立即购买<em>订购检测个数</em>才能使用，购买后会自动充值检测个数，若没有充值成功可联系客服。
            </p>
            <p class="mt5">
                <i>3</i
                >使用我们违禁词检测功能后，我们<em>不能保证百分百</em>不被职业打假人举报，如因图片格式特殊、图片太小、图片文字被遮挡或模糊等特殊原因导致未检测出违禁词，我们将不承担责任。
            </p>
            <p class="mt5"><i>4</i>付费后，<em>无法退款</em>。若对检测结果有疑问可以联系客服。</p>
        </div>
        <productChoose ref="productChoose" />
        <purchaseMenu ref="purchaseMenu" @success="getFwCount" />
        <purchaseRecord ref="purchaseRecord" />
        <taskProgress ref="taskProgress" />
        <newTaskProgress ref="newTaskProgress" />
    </div>
</template>
<script>
import taskProgress from '../components/common/progress/progress';
import productChoose from '../components/common/productChoose/productChoose.vue';
import badge from '../components/common/badge';
import purchaseMenu from '../components/purchaseMenu';
import purchaseRecord from '../components/purchaseRecord';
import newTaskProgress from '../components/common/progress/newProgress';

const TOKEN = localStorage.getItem('accessToken') || localStorage.getItem('sjzlAccessToken');
export default {
    name: 'CheckCenter',
    components: {
        badge,
        productChoose,
        taskProgress,
        purchaseMenu,
        purchaseRecord,
        newTaskProgress,
    },
    data() {
        return {
            loading: false,
            fwWord: true, // 文字违禁词
            fwAttribute: false, // 属性违禁词
            fwSku: false, // SKU违禁词
            fwImage: false, // 图片违禁词
            fwRechargeCount: 0, // 剩余产品图片检测个数
            productionPosition: 0, // 0->销售中；1->待上架
            chooseWay: 0, // 0->全部；1->手动选择；
            goodNums: [
                {
                    totalNum: 0, // 全部数量
                    selectedPro: [], // 手动选择的产品
                },
                {
                    totalNum: 0,
                    selectedPro: [],
                },
            ],
            nolongerShowTip: false,
        };
    },
    computed: {
        showNum({ goodNums }) {
            // 显示的数量
            const way = this.chooseWay;
            const position = this.productionPosition;
            if (way === 0) {
                return goodNums[position].totalNum;
            } else if (way === 1) {
                return goodNums[position].selectedPro.length;
            } else {
                return goodNums[position].classNum;
            }
        },
    },
    created() {
        this.getFwCount();
        if (localStorage.getItem('wjcCenterIgnoreTips')) {
            this.nolongerShowTip = true;
        }
        this.$bus.$on('openNewTaskProgress', this.openNewTaskProgress);
    },

    destroyed() {
        this.$bus.$off('openNewTaskProgress', this.openNewTaskProgress);
    },

    mounted() {
        this.getGoodsNum();
    },
    methods: {
        getGoodsNum() {
            // 获取销售中或待上架的检测数量
            this.chooseWay = 0;
            const num = this.goodNums[this.productionPosition].totalNum;
            if (num !== 0) {
                return;
            }
            this.loading = true;
            this.$ajax
                .post('api/tiktok/Product/SearchListV2', {
                    checkStatus: this.productionPosition === 0 ? [3] : [1, 7],
                    status: this.productionPosition === 0 ? 0 : 1,
                    pageIndex: 1,
                    pageSize: 1,
                })
                .then((res) => {
                    this.loading = false;
                    this.goodNums[this.productionPosition].totalNum = res.result.totalCount;
                });
        },
        //获取套餐数
        getFwCount() {
            this.loading = true;
            this.$ajax.post('//api.fjdaze.com/kuaio/api/ForbiddenWord/PlatformMember/GetFwCount', {}).then((res) => {
                this.loading = false;
                // // 剩余产品图片检测个数
                if (res.result.fwCount <= 0) {
                    this.fwRechargeCount = 0;
                } else {
                    this.fwRechargeCount = res.result.fwCount;
                }
            });
        },
        choosePro() {
            // 手动选择
            const options = {
                productionPosition: this.productionPosition,
                dialogName: '选择商品',
                minNum: 1,
                renderArr: [],
                showStar: true,
                callBack: (res) => {
                    this.goodNums[this.productionPosition].selectedPro = res.data;
                },
            };
            if (this.productionPosition === 1) {
                options.Status = 'Expired';
            }
            this.$refs.productChoose.show(options);
            this.chooseWay = 1;
        },
        showMeal() {
            // 立即购买
            this.$refs.purchaseMenu.show();
        },
        // eslint-disable-next-line max-lines-per-function
        startCheckBtn() {
            // 开始检测按钮
            if (!this.checkRuler()) {
                return;
            }
            const h = this.$createElement;
            if (!this.nolongerShowTip) {
                const href = `https://rule.1688.com/rule/detail.htm?ruleId=3121&amp;spm=a2693.6879473.1367436013.1.lhPwef%3C/a%3E&amp;token=${TOKEN}`;
                this.$msgbox({
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '我知道了',
                    title: '提示',
                    message: h(
                        'div',
                        {
                            class: {
                                font14: true,
                            },
                        },
                        [
                            h('p', null, [
                                h('span', null, ['检测前，请先确保违禁词都已添加至“管理违禁词”列表中。']),
                                h(
                                    'a',
                                    {
                                        attrs: {
                                            href,
                                            target: '_blank',
                                        },
                                        style: {
                                            color: '0064c1',
                                        },
                                    },
                                    ['官方公告']
                                ),
                            ]),
                            h(
                                'el-checkbox',
                                {
                                    on: {
                                        change: (val) => {
                                            this.nolongerShowTip = val;
                                        },
                                    },
                                },
                                ['下次不再提示']
                            ),
                        ]
                    ),
                })
                    .then(() => {
                        if (this.nolongerShowTip) {
                            localStorage.setItem('wjcCenterIgnoreTips', 'ignoreTips20210330');
                        }
                        this.startCheck();
                    })
                    .catch(() => {});
            } else {
                this.startCheck();
            }
        },
        checkRuler() {
            // 规则验证
            const way = this.chooseWay;
            let isPass = true;
            let tip;
            const count = this.showNum;
            if (count === 0) {
                isPass = false;
                tip =
                    way === 0
                        ? '店铺没有产品，请先添加产品再检测'
                        : way === 1
                        ? '请先选择产品'
                        : '该自定义分类没有产品，请重新选择一个分类';
            }
            if (!isPass) {
                this.$message.warning(tip);
                return false;
            }
            if (this.fwImage) {
                // 选择图片违禁词
                const fwRechargeCount = this.fwRechargeCount;
                if (count > fwRechargeCount) {
                    tip = '亲，您剩余的产品图片检测数量不足，请先购买对应的数量，再继续使用。';
                    isPass = false;
                }
                if (!isPass) {
                    this.$confirm(tip, '提示', {
                        confirmButtonText: '立即购买',
                        showCancelButton: false,
                        type: 'warning',
                    })
                        .then(() => {
                            this.showMeal();
                        })
                        .catch(() => {});
                    return false;
                }
            }
            if (!this.fwImage && !this.fwWord && !this.fwAttribute && !this.fwSku) {
                this.$message.warning('请先选择检测内容');
                return false;
            }
            return true;
        },
        // eslint-disable-next-line max-lines-per-function
        startCheck() {
            // 开始检测
            const FwCheckTypes = [];
            if (this.fwWord) {
                FwCheckTypes.push(0);
            }
            if (this.fwImage) {
                FwCheckTypes.push(1);
            }
            if (this.fwAttribute) {
                FwCheckTypes.push(3);
            }
            if (this.fwSku) {
                FwCheckTypes.push(4);
            }
            const way = this.chooseWay;
            const params = {
                FwCheckTypes,
            };
            if (way === 0) {
                params.checkStatus = this.productionPosition === 0 ? [3] : [1, 7];
                params.status = this.productionPosition === 0 ? 0 : 1;
            }
            if (way === 1) {
                // 手动选择
                params.selectProductIds = this.goodNums[this.productionPosition].selectedPro
                    .map((v) => v.productIdStr)
                    .join(',');
            }
            this.loading = true;
            this.$ajax.post('api/tiktok/ForbiddenWordPlan/CreatePlan', params).then((data) => {
                this.loading = false;
                if (data.code !== 200) {
                    this.$message.warning(data.msg);
                    if (data.msg == '您还有任务正在执行中…') {
                        setTimeout(() => {
                            this.$router.push({ name: 'checkRecord' });
                        }, 2000);
                    }
                    return;
                }
                this.$bus.$emit('openNewTaskProgress', {
                    url: 'api/tiktok/ForbiddenWordPlan/CheckOfferForbiddenWord',
                    taskName: '正在执行中',
                    data: {
                        planNo: data.result.planNo,
                    },
                    btns: [
                        {
                            name: '取 消',
                            type: '',
                            autoClose: false, // 点击按钮的时候 是否自动关闭进度条,yo
                            callback: this.cancelTask,
                        },
                        {
                            name: '后台运行',
                            type: 'primary',
                            autoClose: true, // 点击按钮的时候 是否自动关闭进度条
                            callback: null,
                        },
                    ],
                    callBack: () => {
                        setTimeout(() => {
                            this.$router.push({ name: 'checkRecord' });
                        }, 1000);
                    },
                });
            });
        },
        openNewTaskProgress(options, callback) {
            this.$refs.newTaskProgress.show(options);
            callback && callback(this.$refs.newTaskProgress);
        },
        // 取消任务
        cancelTask(component) {
            const cancelTip = '是否取消当前任务';
            this.$confirm(cancelTip, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                dangerouslyUseHTMLString: true,
                type: 'warning',
            })
                .then(() => {
                    component.isOpen = false;
                    this.loading = true;
                    this.$ajax
                        .post('api/tiktok/Task/cancel', {
                            taskId: component.progressData.taskId,
                        })
                        .then((res) => {
                            this.loading = false;
                            if (res.code === 200) {
                                component.dialogVisible = false;
                                this.$message.success(this.successTip || '取消成功!');
                                // this.getData();
                                this.$emit('getRecordList');
                            } else {
                                this.$message.warning('取消失败');
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                })
                .catch(() => {
                    component.isOpen = true;
                });
        },
    },
};
</script>
<style lang="scss">
.check-center {
    background: #fff;
    .blue {
        color: #388eef;
    }
    .orange {
        color: #ff9000;
    }
    .check-center-head {
        line-height: 60px;
        border-bottom: 1px solid #f2f2f4;
        font-size: 12px;
        padding-left: 28px;
    }
    .check-center-body {
        padding: 20px 10px;
        font-size: 14px;
        display: flex;
        .check-center-body-left {
            padding: 0 30px;
            img {
                font-size: 0;
                vertical-align: top;
            }
        }
        .check-center-body-right {
            .check-center-body-item {
                display: flex;
                & + .check-center-body-item {
                    margin-top: 10px;
                }
                .img-check-tip {
                    line-height: initial;
                    padding: 5px 10px;
                    height: auto;
                    margin-left: 0px;
                    font-size: 12px;
                    width: auto;
                    display: inline-block;
                    border: 1px solid #f2e9a7;
                    background-color: #fffbdd;
                    color: #444444;
                    text-align: left;
                }
            }
            .title {
                display: inline-block;
                width: 115px;
                text-align: right;
                margin-right: 5px;
            }
        }
    }
    .check-center-foot {
        border-top: 1px solid #e1e1e1;
        padding: 10px 0 20px 20px;
        h2 {
            color: #4c4b4b;
            font-size: 20px;
            line-height: 40px;
            height: 40px;
        }
        p {
            font-size: 12px;
            line-height: 30px;
            height: 30px;
            i {
                display: inline-block;
                vertical-align: middle;
                margin-right: 12px;
                width: 18px;
                height: 18px;
                line-height: 19px;
                border-radius: 50%;
                background: #e47470;
                text-align: center;
                color: #fff;
                font-family: Arial;
                font-style: oblique;
            }
            em {
                font-size: 14px;
                color: #e91b00;
            }
        }
    }
}
</style>
